export default {
  SET_ITEMS(state, payload) {
    state.invoices = payload
  },

}
